<template>
	<div class="mb-10 w-full space-y-1">
		<h2 class="mb-0 text-left lg:m-auto lg:text-center">
			Frequently asked questions
		</h2>
	</div>
	<div class="xl:px-44">
		<AccordionFaq>
			<AccordionFaqGroup :double-borders="true">
				<AccordionFaqItem>
					<template #title>How soon will I get my car?</template>
					<template #content>
						<div class="space-y-5 text-lg text-gray-575">
							<p>
								We know you’re probably excited to get behind
								the wheel of your new car, so we try to keep the
								process as speedy as possible.
							</p>
							<p>
								You can find out the earliest pick up date for
								your chosen car on the car’s details page. Take
								a look at the info provided above the ‘Get
								Started’ button to find out more.
							</p>
							<p>
								In certain circumstances, we may need to swap
								your car (e.g. if there is a maintenance or
								other issue) – in which case we will, subject to
								availability, try to replace the car with an
								equivalent car.
							</p>
						</div>
					</template>
				</AccordionFaqItem>
				<AccordionFaqItem>
					<template #title>Can I swap my car subscription?</template>
					<template #content>
						<div class="space-y-5 text-lg text-gray-575">
							<p>
								A car subscription service is a flexible
								alternative to buying, financing or leasing a
								car.*
							</p>
							<p>
								Simply order your next car online and give the
								team 2 weeks notice to swap your car
								subscription.
							</p>
							<p>
								Upfront fees apply to swaps, but if you have
								been subscribed for more than 12 months you will
								receive a promo code to discount the upfront fee
								by 50%.
							</p>
							<TermsAndConditions
								:is-full-width="false"
								class="mt-8"
							>
								*
								<CarbarLink
									href="/terms-and-conditions/car-subscription"
									text="Terms and conditions"
									target="_blank"
									:font-size="'text-xsm'"
								/>
								apply.
							</TermsAndConditions>
						</div>
					</template>
				</AccordionFaqItem>
				<AccordionFaqItem>
					<template #title>What is the upfront fee for?</template>
					<template #content>
						<div class="space-y-5 text-lg text-gray-575">
							<p>
								The upfront fee for our subscription services is
								to cover the fees and charges of procuring the
								vehicle, cleaning and detailing, comprehensive
								service and safety checks, as well as setting up
								the car for pick up.
							</p>
							<p>
								The upfront fee varies for each car depending on
								the year, make and model selected.
							</p>
							<p>
								At carbar, we keep things transparent so you
								always know exactly what to expect. You can find
								out more about our subscription fees and charges
								before making your final decision.
							</p>
						</div>
					</template>
				</AccordionFaqItem>
				<AccordionFaqItem>
					<template #title>
						Can I buy my car subscription car?
					</template>
					<template #content>
						<div class="space-y-5 text-lg text-gray-575">
							<p>
								At any time you can buy or finance your
								subscription car.
							</p>
							<p>
								Since we started offering a subscription
								service, we have observed a trend of customers
								subscribing to cars, loving them and often
								asking to purchase the car.
							</p>
							<p>
								Subscribers can simply request a price to
								purchase their subscription car and we’ll help
								compare the costs of financing without any
								impact on their credit rating. This way, you can
								easily weigh up the costs of a subscription
								versus buying a car using finance.
							</p>
							<p>
								We’re always adding new cars to our fleet.
								Browse the latest selection of cars here.
							</p>
						</div>
					</template>
				</AccordionFaqItem>
			</AccordionFaqGroup>
		</AccordionFaq>
	</div>
</template>

<script setup>
import AccordionFaq from '@/components/faqs/AccordionFaq.vue'
import AccordionFaqGroup from '@/components/faqs/AccordionFaqGroup.vue'
import AccordionFaqItem from '@/components/faqs/AccordionFaqItem.vue'
import CarbarLink from '@/components/links/CarbarLink.vue'
import TermsAndConditions from '@/components/fineprint/TermsAndConditions.vue'
</script>
